module.exports = __webpack_public_path__ + "static/media/logo.72119069.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.svg
// module id = 1279
// module chunks = 0